var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHero2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 651,
    height: 803,
    viewBox: "0 0 651 803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "49.996%",
    x2: "49.996%",
    y1: "125.274%",
    y2: "-15.132%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C1B8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "13%",
    stopColor: "#CAC3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "71%",
    stopColor: "#F0EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "49.999%",
    x2: "49.999%",
    y1: "273.749%",
    y2: "-32.137%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C1B8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "13%",
    stopColor: "#CAC3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "71%",
    stopColor: "#F0EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M450.316 114.278c4.356 20.727 11.42 36.398 19.155 48.115 23.152 35.263 50.97 37.11 77.483 42.896 26.513 5.785 65.965 30.661 84.842 81.255 14.685 39.283 16.952 56.056 18.453 111.479 1.502 55.423-62.88 101.95-64.643 157.308-1.06 32.525 12.808 73.136 9.235 131.266-3.573 58.13-143.008 164.941-302.903 83.994-110.702-62.619-137.264 9.026-238.324 3.063-17.328-1.62-46.125-30.548-50.742-59.572-6.804-42.783 4.225-76.28 18.959-116.762C39.517 548.833 66.552 505.483 93 462.392c6.657-10.89 13.346-21.862 18.176-33.919 7.293-18.231 10.116-38.52 9.545-58.534a179.042 179.042 0 0 0-14.032-64.823c-7.44-17.486-17.654-33.416-24.082-51.388-10.997-30.791-10.181-65.244-5.384-97.931 6.232-42.491 14.83-56.412 37.885-90.703C137.95 31.305 190.993 9.703 228.193 3.188c.913-.162 1.827-.34 2.724-.567l2.937-.73c.685-.166 1.384-.27 2.089-.307 52.912-3.08 89.736-3.679 128.258 19.236 46.843 28.684 84.565 67.189 88.937 106.957",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D163D",
    d: "M466 784v19h58v-8.405L487.064 784"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M165.855 683L149 689.116 167.546 743l7.454-2.706-2.426-37.731"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4738A7",
    d: "M388.973 513s76.182 103.772 82.29 126.137C477.37 661.502 484 784 484 784h-20.674L432.15 663.507S353.47 590.17 348 568.209"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5648B6",
    d: "M389 514.077c-6.578 15.855-69.074 144.136-69.074 144.136L173.292 709 164 683.088l100.733-54.933L297.28 503"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBB5A9",
    d: "M429.34 390c2.788 3.179 15.297 27.687 19.182 42.436 10.349 2.289 66.09-14.956 66.09-14.956s17.99-11.666 18.925-11.3c-.839 3.337 7.463 21.281 7.463 21.281l-21.987 5.913s-68.492 37.032-88.255 28.29c-5.835-2.51-17.732-21.615-19.118-25.43-1.386-3.814-8.64-34.965-8.64-34.965L429.34 390z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB74C",
    d: "M384.745 322.475c18.01-6.72 58.267 59.935 51.496 66.295-6.772 6.36-45.845 21.548-52.877 16.054-7.031-5.493-17.636-75.204 1.38-82.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD45C",
    d: "M372.763 313.119c69.326 9.066 29.885 168.024 21.281 201.704-15.104 7.929-86.872 4.874-92.742-11.779-2.28-20.845 7.1-195.238 71.461-189.925z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBB5A9",
    d: "M286.103 369.263c-3.053 3.254-43.003 38.633-54.387 59.203s-10.166 65.095-14.405 76.698c-5.521 14.94-7.616 15.102-8.298 24.85-.358 5.224 6.918 14.647 11.254 14.94 4.336.293 14.307-.342 17.864-15.997-.617-12.157 11.157-78.88 18.318-86.593 7.162-7.714 59.877-46.51 62.378-50.448 2.5-3.939-22.752-33.15-32.724-22.653zM379 326.305c0 4.814-24 5.039-24 0V291h24v35.305z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7BDAD",
    d: "M374.626 223c-15.118 0-27.373 18.796-27.373 41.992 0 1.273 0 2.499.115 3.74-2.281.89-3.65 3.189-3.319 5.573.33 2.384 2.276 4.24 4.717 4.502 3.734 16.41 13.9 28.193 25.86 28.193C389.744 307 402 288.204 402 265.008 402 241.812 389.794 223 374.626 223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D163D",
    d: "M376.306 217.864c-9.303 0-31.626 7.507-40.946 7.507-26.205 0-25.5-9.371-52.066-9.371-13.955 0-29.612 9.206-47.497 16.862-18.508 7.936-42.797 6.6-42.797 40.29C193 284.39 196.521 321 234.863 321c27.99 0 55.015-25.31 80.909-25.31 10.744 0 18.753 2.822 27.843 2.822 5.569 0 12.087-.94 13.938-2.822V279.77s-1.212.94-5.569.94c-1.867 0-3.734-3.745-3.734-5.626 0-9.9 51.166-14.618 51.166-32.784a56.102 56.102 0 0 1 3.833 11.55 17.99 17.99 0 0 0 4.75-11.995c.147-12.985-9.86-23.99-31.693-23.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC74E",
    d: "M351.76 332.5c14.591 12.347-24.318 78.28-33.148 75.409-8.83-2.872-41.047-29.37-39.562-38.032 1.485-8.662 57.336-50.41 72.71-37.377z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 415,
    r: 12,
    fill: "#FBB5A9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M526.96 388.792l32.19-7.75 13.37 54.83-32.19 7.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M30.287 6.735C16.582 5.777 4.64 17.787 1.56 30.98c-3.08 13.194.741 26.956 5.666 39.582 5.733 14.72 13.458 29.341 26.141 38.949 12.683 9.607 31.297 12.983 44.837 4.544 12.502-7.839 17.69-23.873 16.24-38.413-1.449-14.541-8.367-27.93-15.615-40.67-6.77-11.862-14.462-24.05-26.52-30.671-12.057-6.622-29.649-5.388-37.028 6.15",
    opacity: 0.75,
    transform: "translate(493 38)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7B6FC",
    d: "M53.646 684.224c-1.516.927-.114 4.784 1.63 7.616a146.92 146.92 0 0 0 18.325 23.89l1.06-.585c4.532-2.783 8.917-3.906 9.781-2.506.864 1.4-2.07 4.72-6.52 7.486l.716.7c4.419-2.62 8.608-3.662 9.44-2.295.831 1.367-1.419 3.938-5.005 6.51 25.041 22.783 53.8 35.136 70.46 38.96L167 755.749l-6.195-10.074c-10.89-17.657-90.856-71.427-107.159-61.451z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BAA4FC",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M76 699s45.472 21.388 60 41M105 729.263c4.335 1.139 8.803.74 13-1.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BAA4FC",
    d: "M292.992 705.384c-.098-1.253-4.149-1.553-7.482-1.303a210.124 210.124 0 0 0-29.812 4.359c0 .267 0 .534.082.818.261 3.774-.85 6.93-2.483 7.047-1.634.117-3.153-2.772-3.447-6.496l-.964.25c.196 3.641-.915 6.68-2.516 6.764-1.6.083-2.777-2.138-3.267-5.21-32.001 9.05-56.75 23.696-68.103 33.198l.784 11.189 11.827-.868c20.616-1.47 106.329-36.188 105.381-49.748z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C7B6FC",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M269 719s-40.661 21.069-65 24M230 727s-4.067 4.922-5 11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7B6FC",
    d: "M221.54 578.302c-1.868-1.402-6.133 2.33-8.926 5.95a213.232 213.232 0 0 0-21.969 35.125c.397.31.827.587 1.24.896 5.604 4.222 9.042 9.096 7.654 10.872-1.389 1.777-6.927-.146-12.48-4.254l-.563 1.239c5.356 4.14 8.58 8.818 7.224 10.562-1.355 1.744-5.67.26-10.497-2.901-17.422 42.851-20.034 85.05-17.29 107.707L182.563 756l9.917-12.893c17.406-22.493 49.193-149.663 29.06-164.805z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BAA4FC",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M212 618s-6.554 68.37-24 97M188 667c1.059 6.941 3.814 13.484 8 19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BAA4FC",
    d: "M82.591 560.053c-1.99.292-1.858 7.29-.987 12.987a387.468 387.468 0 0 0 11.331 50.668c.412 0 .84-.162 1.283-.227 5.954-.893 11.134.666 11.512 3.458.379 2.792-3.947 5.73-9.867 6.656.164.552.345 1.088.526 1.624 5.756-.731 10.674.795 11.101 3.539.362 2.435-2.977 5.016-7.795 6.234 19.06 53.882 45.933 94.63 62.659 113.008L180 755.37l-3.092-20.212c-5.295-35.261-72.954-178.303-94.317-175.105z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C7B6FC",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M105 601s41.437 68.052 50 110M126 667s7.035 9.368 15 11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M251 752.167c-44.59-21.528-123 12.306-123 12.306L180.209 786 251 752.167z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 548,
    cy: 300,
    r: 26,
    fill: "#FFD77D",
    stroke: "#FFB03A",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFB03A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.5,
    d: "M546 296l-13 13M551.115 302.31L557 302l-8 11M541 292.129s6.631-8.158 13 1.871M567 292.414s-6.45 8.942-13-1.414"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.5,
    cy: 283.5,
    r: 2.5,
    stroke: "#FFB03A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 95.5,
    r: 31.5,
    fill: "#FFD77D",
    stroke: "#FFB03A",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFB03A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.5,
    d: "M235 98l-13 15M240.923 100.371L249 100l-11 13M227 88.202s9.725-8.284 19 1.798M264 92.406s-9.465 8.955-19-1.406"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 253.5,
    cy: 82.5,
    r: 2.5,
    stroke: "#FFB03A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 513,
    r: 26,
    fill: "#FFD77D",
    stroke: "#FFB03A",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFB03A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.5,
    d: "M123 513l-13 13M125.118 518.231L131 518l-8 8M115 509.211s6.642-8.3 13 1.789M144 509.41s-6.448 8.948-13-1.41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.5,
    cy: 500.5,
    r: 2.5,
    stroke: "#FFB03A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero2);
export default __webpack_public_path__ + "static/media/hero-2.0c181d1844141bb45dac6c2207a0eb92.svg";
export { ForwardRef as ReactComponent };